const SHARE_SCALE = 1_000_000;
const SHARE_STEP = 1 / SHARE_SCALE;

const roundToSharePrecision = (value: number): number =>
  Math.round(value * SHARE_SCALE) / SHARE_SCALE;

export const formatSellQuantity = (value: number): string =>
  roundToSharePrecision(value)
    .toFixed(6)
    .replace(/\.?0+$/, "");

export const clampSellQuantityInput = (
  rawValue: string,
  maxShares: number,
): { value: string; wasClamped: boolean } => {
  if (!rawValue) {
    return { value: "", wasClamped: false };
  }

  const parsedValue = Number(rawValue);
  if (!Number.isFinite(parsedValue)) {
    return { value: rawValue, wasClamped: false };
  }

  const roundedMaxShares = roundToSharePrecision(Math.max(0, maxShares));
  if (parsedValue > roundedMaxShares) {
    return {
      value: formatSellQuantity(roundedMaxShares),
      wasClamped: true,
    };
  }

  return { value: rawValue, wasClamped: false };
};

export const stepSellQuantity = (
  currentValue: string,
  maxShares: number,
  direction: "up" | "down",
): string => {
  const roundedMaxShares = roundToSharePrecision(Math.max(0, maxShares));
  if (roundedMaxShares <= 0) {
    return "";
  }

  const currentNumber = Number(currentValue);
  const currentShares = Number.isFinite(currentNumber)
    ? roundToSharePrecision(currentNumber)
    : 0;

  const nextShares =
    direction === "up"
      ? Math.min(roundedMaxShares, currentShares + SHARE_STEP)
      : Math.max(0, currentShares - SHARE_STEP);

  if (nextShares <= 0) {
    return "";
  }

  return formatSellQuantity(nextShares);
};
